// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".color--primary[data-v-2137b32e]{color:#c81919}", ""]);
// Exports
module.exports = exports;
